module.exports = __webpack_public_path__ + "img/cart-dash.8f023a6e.svg";